import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { Payment } from "~/providers/order-provider";
import { useOrderManager } from "~/managers/use-order-manager";
import { RegisterButton } from "../ui/register-button";

export default function PaymentScreen({
  onClose,
  payment,
}: {
  onClose: () => void;
  payment: Payment;
}) {
  const [voidingPayment, setVoidingPayment] = useState(false);
  const { t } = useTranslation("common");
  const { voidPayment } = useOrderManager();
  const handleVoidPayment = async () => {
    setVoidingPayment(true);
    const result = await voidPayment(payment.id);
    setVoidingPayment(false);
    if (result === true) {
      onClose();
    }
  };

  const handleTransferPayment = async () => {
    alert("Coming soon. Contact support.");
    onClose();
  };
  return (
    <div className="flex flex-row gap-4">
      <RegisterButton disabled={voidingPayment} onClick={handleTransferPayment}>
        {t("Checkout.transfer_payment")}
      </RegisterButton>
      <RegisterButton
        disabled={voidingPayment || !!payment.externalId}
        onClick={handleVoidPayment}
      >
        {t("Checkout.void_payment")}
      </RegisterButton>
    </div>
  );
}
